/* eslint-disable no-console */ 'use strict';
var inputs = document.querySelectorAll('form input');
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var input = _step.value;
        var label = document.createElement('label');
        var inputParent = input.closest('div');
        var inputName = input.name.split(/(?=[A-Z])/).join(' ');
        var inputPlaceholder = inputName.charAt(0).toUpperCase() + inputName.slice(1);
        label.classList.add('field-label');
        label.htmlFor = input.id;
        label.textContent = inputName.toUpperCase();
        input.placeholder = inputPlaceholder;
        inputParent.append(label);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

//# sourceMappingURL=js_task_fix_form_DOM.d166cf12.js.map
